var map = {
	"./1 Vakratunda Sawha.jpg": 8268,
	"./2 Vakratunda Sawha.jpg": 357,
	"./4 Vakratunda Sawha.jpg": 7011,
	"./6 Vakratunda Sawha.jpg": 7793,
	"./7 Vakratunda Sawha.jpg": 8518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2760;